
export const replaceSymbolToDots = (login: string) => {
  const firstLetters = login.split("").slice(0, 2);
  const lastLetters = login.split("").slice(-2);
  const arr = [...firstLetters, "....", ...lastLetters];
  return arr.join("");
};
